/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
// eslint-disable-next-line
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, Table } from 'reactstrap'; // eslint-disable-next-line
import avatar_img from '../../assets/img/team/avatar.svg'; // eslint-disable-next-line
import Badge from 'reactstrap/es/Badge'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader'; // eslint-disable-next-line
import default_avatar from '../../assets/img/team/avatar.svg'; // eslint-disable-next-line
import UserDegreeHistroyAccordion from './accordion/UserDegreeHistroyAccordion';
const UserProfileDegreeHistory = props => {
	const { data, pageLanguageContent, profileId, currentActiveTab } = props;
	const [userDegreeData, setUserDegreeData] = useState([]);
	const [showData, setShowData] = useState(false);
	useEffect(() => {
		if (currentActiveTab && currentActiveTab === '5' && userDegreeData.length <= 0) {
			getUserDegreeHistory(profileId);
		}
		// eslint-disable-next-line
	}, [props]);

	function getUserDegreeHistory(profileId) {
		setShowData(false);
		copiriPortalRequest('/users/' + profileId + '/rank/history', config.app_version, 'get')
			.then(response => {
				setUserDegreeData(response?.data?.history);
				setShowData(true);
			})
			.catch(error => {
				setShowData(false);
			});
	}

	return (
		<fieldset className='border p-2'>
			<legend className='w-auto'>{pageLanguageContent['PRL161'] ? pageLanguageContent['PRL161'] : ''}</legend>
			{showData ? (
				<div className='legendAccordian'>
					<UserDegreeHistroyAccordion
						userDegreeData={userDegreeData}
						showData={showData}
						data={data}
						pageLanguageContent={pageLanguageContent}
						profileId={profileId}
					/>
				</div>
			) : (
				<CopiriLoader />
			)}
		</fieldset>
	);
};
export default UserProfileDegreeHistory;
